import { useEffect } from 'react'
import type { MachineExercise } from '../lib/machines'

interface Props {
  open: boolean
  machines: MachineExercise[]
  onClose: () => void
  onPick: (machine: MachineExercise) => void
}

/** Prompt when one QR sticker maps to more than one workout configuration. */
export function WorkoutPickModal({ open, machines, onClose, onPick }: Props) {
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open || machines.length === 0) return null

  return (
    <div className="modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="workout-pick-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="modal-header">
          <h2 id="workout-pick-title">Workout name</h2>
          <button type="button" className="icon-btn" onClick={onClose} aria-label="Close">
            X
          </button>
        </header>

        <p className="muted small">
          This machine QR matches more than one workout. Pick which configuration you are logging.
        </p>

        <ul className="workout-pick-list">
          {machines.map((m) => (
            <li key={m.id}>
              <button type="button" className="btn-primary workout-pick-btn" onClick={() => onPick(m)}>
                {m.name}
              </button>
              {m.notes ? <p className="muted small">{m.notes}</p> : null}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
